const element = document.querySelector("#shipping_price_close");
if (element) {
  element.addEventListener("click", () => {
    const element = document.querySelector("#shipping_price");
    element.style.display = "none";
  });
}

async function handleFreeShipping() {
  try {
    const cep = document.querySelector("#cep");
    cep.classList.remove('!border-red-500');
    if (cep.value.trim() === "" || cep.value === undefined) {
      cep.classList.add('!border-red-500');
      return;
    }

    const getShippPriceLoading = document.getElementById("getShippPriceLoading");
    getShippPriceLoading.innerHTML = '';
    var loading = document.createElement("span");
    loading.className = "flex justify-center items-center whitespace-nowrap font-semibold text-slate-900";
    loading.innerHTML = `<svg class="animate-spin h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>`;
    getShippPriceLoading.appendChild(loading)

    const shippings = await fetch(`https://viacep.com.br/ws/${cep.value}/json`, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "get",
    });

    if (shippings.ok) {
      const shipping = await shippings.json();
      const country = "br";
      const posTax = `/cart/prepare_shipping_rates.json?shipping_address[zip]=${shipping.cep}&shipping_address[country]=${country}&shipping_address[province]=${shipping.uf}`;
      const getTax = `/cart/async_shipping_rates.json?shipping_address[zip]=${shipping.cep}&shipping_address[country]=${country}&shipping_address[province]=${shipping.uf}`;

      await fetch(`${posTax}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
      });

      const response = await fetch(`${getTax}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "get",
      });

      if (!response.ok) {
        getShippPriceLoading.innerHTML = 'OK';
        throw new Error(`Erro na requisição: ${response.statusText}`);
      }

      const shippingList = document.querySelector("#shipping_price_list");
      const shippingOption = document.querySelector("#shipping_price_option");
      document.querySelectorAll('#shipping_price_option').forEach(item=>{
        item.classList.remove('hidden');
      })
      const data = await response.json();

      if (data === null || data === undefined) {
        handleFreeShipping()
        return
      };

      shippingOption.innerHTML = `Você tem ${data?.shipping_rates.length ?? 0} frete(s)`;

      shippingList.innerHTML = "";
      data?.shipping_rates?.forEach((rate) => {
        const listItem = document.createElement("li");
        listItem.innerHTML = `
        <li>
          <div class="flex justify-between items-start">
              <span class="flex flex-col">
                  <p class="font-semibold">${rate.presentment_name}</p>
                  <p class="text-base">Receba até ${formatarDate(rate.delivery_date)}</p>
              </span>
              <p class="font-semibold">${formatarPreco(rate.price, rate.currency)}</p>
          </div>
        </li>
        `;
        shippingList.appendChild(listItem);
      });

      getShippPriceLoading.innerHTML = 'OK';

      return;
    }
  } catch (error) {
    console.error("Erro ao calcular frete:", error);
    throw error;
  } finally {
    const targetDiv = document.getElementById("all-freet-results");
    targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    const getButton = document.getElementById('getShippPriceLoading');
    getButton.innerHTML = 'ok'
  }
}

function formatarDate(date) {
  const options = { day: "numeric", month: "long", year: "numeric" };
  const dataFormatada = new Date(date).toLocaleDateString("pt-BR", options);
  return dataFormatada;
}

function formatarPreco(price, currency) {
  const precoNumerico = parseFloat(price);

  if (precoNumerico === 0) {
    return "Frete Grátis";
  }

  const precoFormatado = precoNumerico.toLocaleString("pt-BR", {
    style: "currency",
    currency: currency,
  });

  return precoFormatado;
}